import { render, staticRenderFns } from "./SpeedrunModeModal.vue?vue&type=template&id=150b576c&"
import script from "./SpeedrunModeModal.vue?vue&type=script&lang=js&"
export * from "./SpeedrunModeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports